import React, { useState } from "react";
import { withStyles, Card, CardContent, CardActions } from "@material-ui/core";
import { validateEmail } from "../../../../Utilities/Functions";
import StepActions from "./stepActions";
import ClientUser from "./clientUser";
import styles from "./styles";

const AssignUserStep = (props) => {
  const {
    clientUsers = [],
    entity,
    request,
    lastClientUser,
    canSkip,
    onCancel,
    onNext,
    onBack,
  } = props;

  const [clientUser, setClientUser] = useState(null);
  const [newUsername, setNewUsername] = useState("");
  const [newUserEmail, setNewUserEmail] = useState("");
  const [userMessage, setUserMessage] = useState("");
  const [userError, setUserError] = useState(false);

  const handleNext = (event) => {
    setUserError(false);
    if (!clientUser) {
      if (!newUsername || !newUserEmail) {
        setUserError({ noUsername: true });
        return;
      } else if (!validateEmail(newUserEmail)) {
        setUserError({ invalidEmail: true });
        return;
      }
    }

    let cu = clientUser;
    if (!cu) {
      cu = { username: newUsername, userEmail: newUserEmail };
    }
    onNext(true, { clientUser: cu, userMessage });
  };

  const handleCancel = (event) => {
    onCancel();
  };

  const handleBack = (event) => {
    onBack();
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <ClientUser
          entity={entity}
          request={request}
          lastClientUser={lastClientUser}
          clientUsers={clientUsers}
          onClientUser={setClientUser}
          onNewUsername={setNewUsername}
          onNewUserEmail={setNewUserEmail}
          onMessage={setUserMessage}
          userError={userError}
        />
      </CardContent>
      <CardActions disableSpacing>
        <StepActions
          canSkip={canSkip}
          onCancel={handleCancel}
          onNext={handleNext}
          onBack={handleBack}
        />
      </CardActions>
    </Card>
  );
};

export default withStyles(styles, { withTheme: true })(AssignUserStep);
